import React, { useState } from 'react';
import {IContactMessengersProps} from './~types/ContactMessengersProps';
import { ChannelType } from 'src/app/contact/~store/models/ChannelType';

import './ContactMessengers.css';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { GetChannelImage } from '../../../../../shared/helpers/img-helpers/ImgHelper';

const ContactMessengers = (props: IContactMessengersProps) => {
    const { t } = useTranslation();
    const [hoveredMessengerId, setHoveredMessengerId] = useState(0);

    const _mapMessengersToElement = () => {
        const {messengers} = props;
        if(messengers)
            return (
                <React.Fragment> 
                    {messengers.map((messenger, index) => {
                        const icon = GetChannelImage(messenger.channelModel.type);

                        return ( 
                            <div key={messenger.messengerId} className="contact-messenger">
                                <img 
                                    className="contact-messenger__icon"
                                    onClick={() => props.newChatWithMessenger?.(messenger)}
                                    src={icon} 
                                    width={20} 
                                    height={20} />
                                <p className="contact-messenger__id">
                                    {messenger.externalId}
                                </p>
                                {(messenger.messengerId === hoveredMessengerId) && props.isNeedDetach && <Button
                                    className="contact-messenger__detach-button"
                                    onClick={() => {props.detach?.(messenger.messengerId)}}>
                                    {t('common.detach')}
                                </Button>}
                            </div>
                        )
                    })}
                </React.Fragment>
            )
        else 
            return (
                <div>

                </div>
            )
    }

    return(
        <React.Fragment>
            {_mapMessengersToElement()}
        </React.Fragment>
    )
}

export default ContactMessengers;